import GenericDictionaryPage from "./GenericDictionaryPage";
import { getAlertDeleteReason } from "../api/alertDeleteReason";

export default function AlertDeleteReason() {
    return (
        <GenericDictionaryPage
            tableKey="alertDeleteReason"
            fetchData={getAlertDeleteReason}
            titleKey="genericDic:alertDeleteReason"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:alertDeleteReason").toLowerCase()
                })
            }
        /> 
    );
}
